export const APP_VERSION = 'mobile-2026.09.01.192930';
export const APP_NAME = 'mobile';
